'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X } from 'lucide-react';

export default function LandingNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background/90 backdrop-blur-md border-b border-border shadow-lg' : 'bg-transparent'
      }`}
    >
      <nav className="max-w-screen-xl mx-auto px-6 lg:px-10 flex items-center justify-between h-16">
        <div className="flex items-center gap-2.5">
          <AppLogo size={34} />
          <span className="font-bold text-base text-foreground tracking-tight">
            Fan<span className="text-primary">Finite</span>
          </span>
        </div>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-8">
          {[
            { label: 'Features', href: '#features' },
            { label: 'Psych World', href: '#psych-world' },
            { label: 'XP System', href: '#xp-system' },
            { label: 'ID Card', href: '#id-card' },
            { label: 'Coming Soon', href: '#expansion' },
          ]?.map((link) => (
            <a
              key={`nav-${link?.label}`}
              href={link?.href}
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors duration-150"
            >
              {link?.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            href="/sign-up-login-screen"
            className="text-sm font-semibold text-muted-foreground hover:text-foreground transition-colors duration-150 px-4 py-2"
          >
            Sign In
          </Link>
          <Link
            href="/sign-up-login-screen"
            className="text-sm font-bold bg-primary text-primary-foreground px-5 py-2 rounded-xl hover:bg-primary/90 transition-all duration-150 active:scale-95"
          >
            Get Early Access
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden p-2 text-muted-foreground hover:text-foreground"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle mobile menu"
        >
          {mobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>
      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-card border-t border-border px-6 py-4 space-y-3">
          {['Features', 'Psych World', 'XP System', 'ID Card', 'Coming Soon']?.map((item) => (
            <a
              key={`mobile-nav-${item}`}
              href={`#${item?.toLowerCase()?.replace(' ', '-')}`}
              className="block text-sm font-medium text-muted-foreground hover:text-foreground py-2"
              onClick={() => setMobileOpen(false)}
            >
              {item}
            </a>
          ))}
          <div className="pt-3 border-t border-border flex flex-col gap-2">
            <Link href="/sign-up-login-screen" className="text-sm font-semibold text-center py-2.5 border border-border rounded-xl text-foreground hover:bg-muted transition-all duration-150">
              Sign In
            </Link>
            <Link href="/sign-up-login-screen" className="text-sm font-bold text-center py-2.5 bg-primary text-primary-foreground rounded-xl hover:bg-primary/90 transition-all duration-150">
              Get Early Access
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}